// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"2e1e13f5","453":"62454177"}[chunkId] + ".chunk.js";
};